import React, { useState, useEffect } from 'react';
import { Box, Typography, Drawer, IconButton, Button  } from '@mui/material';

import { useMediaQuery } from "@mui/material";

import { collection, onSnapshot, doc, getDocs,setDoc, writeBatch, deleteDoc, updateDoc, addDoc, query, where } from 'firebase/firestore';
import {db} from '../../firebaseConfig';

import CloseIcon from '@mui/icons-material/Close';

import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import EditIcon from '@mui/icons-material/EditOutlined';

import PdfThumbnail from '../../images/PdfThumbnail.png'; // import a component or image for PDF thumbnail
import GenericFileThumbnail from '../../images/GenericFileThumbnail.png'; // import a component or image for generic file thumbnail

import { useTheme } from "@mui/material";

import { tokens } from "../../theme";

import { useUser } from "../../common/UserContext";
import { useApplicationMode } from "../../common/ApplicationModeContext";



    const generateProductColorMapDrawer = (productionBatches, productMap,theme) => {

    const productIdColorMap = {};
    
    const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;
    
    productionBatches.forEach(productionBatch => {
        if (!productIdColorMap[productionBatch.productId]) {
        productIdColorMap[productionBatch.productId] = colorFunction(productionBatch.productId);
        }
    });
    
    return productIdColorMap;
    };
    
const generateStatusColorMapDrawer = (productionBatches,theme) => {
  
        const statusColorMap = {};
        
        const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;

        productionBatches.forEach(productionBatch => {
          if (!statusColorMap[productionBatch.status]) {
            statusColorMap[productionBatch.status] = colorFunction(productionBatch.status);
          }
        });
      
        return statusColorMap;
      };
      


const stringToColorLight = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF;
    // Ensuring that the color values are always light by adding a base value of 127
    const lightValue = ((value + 127) % 128) + 127;
    color += ('00' + lightValue.toString(16)).substr(-2);
  }
  return color;
};


const stringToColorDark = (str) => {
  
  return stringToColorLight(str); // We will use the same colors
};


const ProductionBatchDrawerModal = ({ drawerOpen, handleDrawerClose,handleArrowUpClick,handleArrowDownClick, selectedProductionBatch, productionBatches, handleOpenEdit }) => {

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const { appUserAccountNumber } = useUser();
  const { applicationMode } = useApplicationMode();
    
  const data = selectedProductionBatch;

  const [productMap, setProductMap] = useState({});
const [assignedBakerMap, setAssignedBakerMap] = useState({});

  
  
                const formatProduct = value => {

                    let formattedProduct = "";

                    if (value != null && value !=="")
                    {
                    formattedProduct = productMap[value];
                    }
                    
                    return formattedProduct;
                };
    
                

                const formatAssignedBaker = value => {

                    let formattedAssignedBaker = "";

                    if (value != null && value !=="")
                    {
                    formattedAssignedBaker = assignedBakerMap[value];
                    }
                    
                    return formattedAssignedBaker;
                };
    
                

  
  
    useEffect(() => {
        const fetchStaticData = async () => {
            	const productSnapshot = await getDocs(query(collection(db, "products"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode)));
	const productData = productSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	const productMap = productData.reduce((acc, ref) => ({ ...acc, [ref.id]: ref.name }), {});
	setProductMap(productMap);

	const assignedBakerSnapshot = await getDocs(query(collection(db, "employees"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode)));
	const assignedBakerData = assignedBakerSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	const assignedBakerMap = assignedBakerData.reduce((acc, ref) => ({ ...acc, [ref.id]: ref.firstName+ " " +ref.lastName }), {});
	setAssignedBakerMap(assignedBakerMap);



        };

        fetchStaticData();
      }, []);
    
    

  const [productColorMap, setProductColorMap] = useState({});
const [statusColorMap, setStatusColorMap] = useState({});


//USE EFFECT TO CHANGE COLOR MAP when it changes
useEffect(() => {
  setProductColorMap(generateProductColorMapDrawer(productionBatches, productMap,theme));
setStatusColorMap(generateStatusColorMapDrawer(productionBatches,theme));

}, [theme.palette.mode, drawerOpen, productionBatches ]);


  const formatFirestoreDate = timestamp => {

    if (timestamp != null && timestamp !== "")
    {
      const dateStr = new Date(timestamp.seconds * 1000).toISOString().slice(0, 10);
      const parts = dateStr.split('-');
      return `${parts[1]}/${parts[2]}/${parts[0]}`;
    } else 
    {
      return "";
    }
  };

  const formatFirestoreTime = timestamp => {

   if (timestamp != null && timestamp !== "")
   { 
        // Convert the seconds since Unix epoch to a Date object
      const date = new Date(timestamp.seconds * 1000);

      // Extract hours and minutes
      let hours = date.getHours();
      const minutes = date.getMinutes();

      // Determine AM or PM
      const period = hours >= 12 ? 'PM' : 'AM';

      // Convert hours to 12-hour format
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'

      // Format hours and minutes as a time string in "hh:mm AM/PM" format
      const formattedHours = hours.toString().padStart(2, '0');
      const formattedMinutes = minutes.toString().padStart(2, '0');

      return `${formattedHours}:${formattedMinutes} ${period}`;
   } else
   {
    return "";
   }
  };


  const formatPhoneNumber = value => {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, '');
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  };

  const formatCurrencyInteger = value => {
  
    if (value != null && value !=="")
    {
      return `$${Number(value).toLocaleString()}`;
    } else 
    {
      return "";
    }
  };

  const formatCurrency = (value) => {

    if (value != null && value !=="")
    {
          value = value.toString();
          // Remove all non-numeric characters except for the decimal point
          let result = value.replace(/[^0-9.]/g, '');
        
          // If there are multiple decimal points, keep only the first one
          const parts = result.split('.');
          if (parts.length > 2) {
            result = parts[0] + '.' + parts.slice(1).join('');
          }
        
          // Allow at most two decimal places
          if (parts.length === 2 && parts[1].length > 2) {
          
            result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1].substring(0, 2);
          } else if (parts.length === 2 && parts[1].length <= 2) 
          {
            result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
          }else
          {
            result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          }
          return result ? `$${result}` : '';

      } else 
      {
        return "";
      }
  };


  const formatDecimal = (value) => {

    if (value != null && value !=="")
    {
          value = value.toString();
          // Remove all non-numeric characters except for the decimal point
          let result = value.replace(/[^0-9.]/g, '');
        
          // If there are multiple decimal points, keep only the first one
          const parts = result.split('.');
          if (parts.length > 2) {
            result = parts[0] + '.' + parts.slice(1).join('');
          }
        
          // Allow at most two decimal places
          if (parts.length === 2 && parts[1].length > 2) {
          
            result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1].substring(0, 2);
          } else if (parts.length === 2 && parts[1].length <= 2) 
          {
            result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
          }else
          {
            result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          }
          return result ? `${result}` : '';
  
      } else 
      {
        return "";
      }
  };
  
  
  const formatInteger = (value) => {
  
    if (value != null && value !=="")
    {
          value = value.toString();
          // Remove all non-numeric characters except for the decimal point
          let result = value.replace(/[^0-9]/g, '');
        
          result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          
          return result ? `${result}` : '';
  
      } else 
      {
        return "";
      }
  };


  const getFileExtension = (fileName) => {
    return fileName.split('.').pop().toLowerCase();
  };

  const renderFile = (fileContent,fileName) => {
    if (!fileContent || !fileName) return null;
    const fileType = getFileExtension(fileName);
    if (fileType === 'pdf') {
      return <img src={PdfThumbnail} title={fileName} alt="PDF thumbnail" onClick={() => handleFileClick(fileType,fileContent,fileName)} style={{ cursor: 'pointer',height:'100px',width:'81px' }} />;
    } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileType)) {
      return <img src={fileContent} title={fileName} alt="Profile thumbnail" onClick={() => handleFileClick(fileType,fileContent,fileName)} style={{ cursor: 'pointer', maxWidth: '400px', maxHeight: '400px' }} />;
    } else {
      return <img src={GenericFileThumbnail} title={fileName} alt="File thumbnail" onClick={() => handleFileClick(fileType,fileContent,fileName)} style={{ cursor: 'pointer',height:'100px',width:'77px'  }} />;
    }
  };

  const handleFileClick = (fileType,fileContent,fileName) => {
    if (fileType === 'pdf') {
      
      const base64String = fileContent.split(',')[1]; // Extract base64 string from data URL
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
  
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);
  
      window.open(blobUrl, '_blank');

    } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileType)) {
      const image = new Image();
      image.src = fileContent;
    
      image.onload = () => {
        let width = image.naturalWidth;
        let height = image.naturalHeight;
        const padding = 50;
    
        // Get browser window dimensions
        const maxWidth = window.innerWidth - padding;
        const maxHeight = window.innerHeight - padding;
    
        // Resize the image if it's larger than the browser window
        if (width > maxWidth || height > maxHeight) {
          const widthRatio = maxWidth / width;
          const heightRatio = maxHeight / height;
          const minRatio = Math.min(widthRatio, heightRatio);
    
          width = Math.floor(width * minRatio);
          height = Math.floor(height * minRatio);
        }
    
        // Calculate the position to center the window
        const left = (window.screen.width / 2) - (width / 2);
        const top = (window.screen.height / 2) - (height / 2);
    
        // Open the window with the calculated position and size
        const w = window.open("", "", `width=${width + padding},height=${height + padding},left=${left},top=${top}`);
        image.style.width = `${width}px`;
        image.style.height = `${height}px`;
        w.document.write(image.outerHTML);
      };
        
    } else {
      const link = document.createElement('a');
      link.href = fileContent;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  

    return (
        <Drawer anchor="right" open={drawerOpen} onClose={handleDrawerClose}>
          <div>
          <Box sx={{ width: 600, padding: 2, backgroundColor:colors.drawerModalBackgroundColor, height: '100%', minHeight: '100vh'  }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">

              {handleArrowDownClick ? (
              <Box display="flex">
                <IconButton onClick={handleArrowUpClick}>
                  <KeyboardArrowUpIcon />
                </IconButton>
                <IconButton onClick={handleArrowDownClick}>
                  <KeyboardArrowDownIcon />
                    </IconButton>
                </Box>

              ) : (
                <Box display="flex">
                  &nbsp;
                </Box>
              )}

                <IconButton onClick={handleDrawerClose}>
                  <CloseIcon />
                </IconButton>
              </Box>
              
                {selectedProductionBatch && (
                    <>
                      <h1>{data.id}</h1>
    <Button variant="contained" color="primary" sx={{ float:'right',backgroundColor: colors.greenAccent[600], color: colors.grey[100], '&:hover': { backgroundColor: colors.greenAccent[800] } }} onClick={() => handleOpenEdit(selectedProductionBatch.id)}>
        <EditIcon /> &nbsp; EDIT PRODUCTIONBATCH
    </Button>
                    
     <Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>BATCHNAME:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>
{data.name ? data.name.toString() : ""}</Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>PRODUCT:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>

                           <Box
                                key={data.productId}
                                sx={{ 
                                    backgroundColor: productColorMap[data.productId], 
                                    borderRadius: '13px', 
                                    padding: '2px 8px', 
                                    display: 'inline-block', 
                                    marginRight: '4px',
                                    marginBottom: '4px',
                                    color: theme.palette.mode === "dark" ? '#000000' : '#000000',
                                    fontWeight:'600'  
                                }}
                                >
                                    {productMap[data.productId]}

                                </Box>
                        </Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>PRODUCTION ORDER ID:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>
{data.productionOrderId ? data.productionOrderId.toString() : ""}</Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>START DATE:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>
{formatFirestoreDate(data.startDate)}</Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>END DATE:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>
{formatFirestoreDate(data.endDate)}</Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>STATUS:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>

                    <Box
                                key={data.status}
                                sx={{ 
                                    backgroundColor: statusColorMap[data.status], 
                                    borderRadius: '13px', 
                                    padding: '2px 8px', 
                                    display: 'inline-block', 
                                    marginRight: '4px',
                                    marginBottom: '4px',
                                    color: theme.palette.mode === "dark" ? '#000000' : '#000000',
                                    fontWeight:'600'  
                                }}
                                >
                                    { data.status ? data.status.toString() : "" }

                                </Box>
                    </Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>QUANTITY PRODUCED:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>
{data.quantityProduced ? data.quantityProduced.toString() : ""}</Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>ASSIGNED BAKER:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>
{formatAssignedBaker(data.assignedBaker)}</Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>NOTES:</Box> <Typography variant='h6' sx={{fontWeight:'500'}}>
{data.notes != null ? data.notes.split('\n').map((line, index) => <React.Fragment key={index}>{line}<br /></React.Fragment>) : ''}</Typography>
</Box><hr/>
                    </>
                )}
            </Box>
            </div>
        </Drawer>
    );
};

export default ProductionBatchDrawerModal;
